import { render, staticRenderFns } from "./FreespinDetailDialog.vue?vue&type=template&id=6d80718c"
import script from "./FreespinDetailDialog.vue?vue&type=script&lang=js"
export * from "./FreespinDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports